import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function Klima() {
  return (
    <>
      
    </>
  )
}
